module.exports = __webpack_public_path__ + "static/gradient2-2555faf716a4aa114c4361a34d2a8bda.png";